// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableWithFilter__prompt___oheLR {
    padding: 0 0.8rem 0.8rem 1.2rem;
}

.TableWithFilter__wrapper___juLVM {
    min-height: 44.8rem;
    max-height: 58.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/TableWithFilter/TableWithFilter.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".prompt {\n    padding: 0 0.8rem 0.8rem 1.2rem;\n}\n\n.wrapper {\n    min-height: 44.8rem;\n    max-height: 58.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prompt": `TableWithFilter__prompt___oheLR`,
	"wrapper": `TableWithFilter__wrapper___juLVM`
};
export default ___CSS_LOADER_EXPORT___;
